import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { CombinedCalendarStore } from '../store/combined-calendar-store';
import { UntypedFormBuilder, UntypedFormGroup, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ConfigService } from '../../../shared/services/config.service';
import { MatCheckbox } from '@angular/material/checkbox';

@Component({
    selector: 'app-quick-filter',
    templateUrl: './quick-filter.component.html',
    standalone: true,
    imports: [ReactiveFormsModule, MatCheckbox]
})
export class QuickFilterComponent implements OnInit {
  filterForm: UntypedFormGroup;

  constructor(
    private fb: UntypedFormBuilder,
    private readonly combinedCalendarStore: CombinedCalendarStore,
    private route: ActivatedRoute,
    private router: Router
  ) {
    this.filterForm = fb.group({
      available: fb.control(true),
      hires: fb.control(true),
      bookings: fb.control(true)
    });
  }

  ngOnInit() {
    this.setInitialFormValueBasedOnRoute();
    this.updateRouteOnFilter();
    this.updateStoreOnRouteChanges();
  }

  private setInitialFormValueBasedOnRoute() {
    this.filterForm.setValue(
      this.queryParamsToFilter(this.route.snapshot.queryParams)
    );
  }

  private updateRouteOnFilter() {
    this.filterForm.valueChanges.subscribe({
      next: (value) =>
        this.router.navigate([], {
          relativeTo: this.route,
          queryParams: value,
          queryParamsHandling: 'merge'
        })
    });
  }

  private updateStoreOnRouteChanges() {
    this.route.queryParams.subscribe((params) => {
      this.combinedCalendarStore.setFilter(this.queryParamsToFilter(params));
    });
  }

  private queryParamsToFilter(params: Params) {
    return {
      available: params['available'] !== 'false',
      hires: params['hires'] !== 'false',
      bookings: params['bookings'] !== 'false'
    };
  }
}
